<template>
    <div ref="container" style="display: block;width: 100%;height: 100%;position: relative"></div>
</template>

<script>
    import Vue from 'vue'
    import Legend from './legend.js'

    export default {
        name:"d3-legend",
        //передоваемые параметры
        props: {
            data: {
                type: Array,
                default: () => ([])
            }
        },
        // локальное состояние
        data() {
            return {
                legend: null
            }
        },

        mounted() {
            this.updateLegend();
            window.addEventListener('resize', () => {
                // setTimeout(this.updateLegend, 0);
            });
        },

        //вычисляемые свойства (https://ru.vuejs.org/v2/guide/computed.html#Вычисляемые-свойства)
        computed: {},
        //Методы для изменения локального состояния.Ограничения (https://ru.vuejs.org/v2/guide/list.html#Отслеживание-изменений-в-массивах)
        methods: {
            updateLegend() {
                const data = this.data;

                let h = (this.$refs.container.clientHeight / data.length);

                if (h > 40) h = 40;

                const options = {
                    w: this.$refs.container.clientWidth,
                    h: h * 0.9,
                    s: h * 0.1,
                    container: this.$refs.container
                };

                this.legend = new Legend(data, options);

                this.legend.addItemMouseClickListener(d => {
                    this.$emit("onItemMouseClick", d);
                });
            }
        },

        components: {},

        watch: {
            data() {
                this.updateLegend();
            }
        }

    }
</script>

<style scoped>

</style>
